
// const new_service_basis = window.gtaAiConfig.service_basis

 /* eslint-disable */ 
 let tag= process.env.VUE_APP_TAG
 let new_service_basis=getEnv(tag).service_basis
 let service_data=getEnv(tag).service_data

export default {
    // 个人空间接口
    /**
     * 获取数据字典数据
     */
    getComDictionary: `${new_service_basis}/ai/training/personlSpace/getComDictionary`,
    /**
     * 获取编辑器类型字典
     */
     getEditorDictionary: `${new_service_basis}/ai/training/personlSpace/getEditorDictionary`,
    /**
     * 查询个人空间项目列表
     */
    getProjectListByUserId: `${new_service_basis}/ai/training/personlSpace/getProjectListByUserId`,
    /**
     * 新增个人空间项目数据
     */
    insertProjectByUserId: `${new_service_basis}/ai/training/personlSpace/insertProjectByUserId`,
    /**
     * 删除个人空间项目数据
     */
    deleteProjectByProjectId: `${new_service_basis}/ai/training/personlSpace/deleteProjectByProjectId`,

    /**
     * 修改个人空间项目数据
     */
    updateProjectByProjectId: `${new_service_basis}/ai/training/personlSpace/updateProjectByProjectId`,
    /**
     * 获取个人空间项目详情数据
     */
    getProjectByProjectId: `${new_service_basis}/ai/training/personlSpace/getProjectByProjectId`,
    /**
     * 保存项目代码
     */
    saveProjectCode: `${new_service_basis}/ai/training/personlSpace/saveProjectCode`,
    /**
     * 保存python编辑器的项目代码
     */
     savePythonProjectCode: `${new_service_basis}/ai/training/personlSpace/savePythonProjectCode`,
    /**
     *  公开个人空间项目数据
     */
    openProjectByProjectId: `${new_service_basis}/ai/training/personlSpace/openProjectByProjectId`,
  
  
}
